import React, { ReactNode, useState } from 'react';
import classNames from 'classnames';
import { IconChevronDown, IconChevronUp } from '@pentabd/icons';

import Text from '../text/Text';
import AnimateHeight, { Height } from 'react-animate-height';
import { SubItems } from './TopBar';
import Dropdown from '../dropdown/Dropdown';

export interface MenuItemProps {
  icon?: ReactNode;
  name?: string;
  submenu?: SubItems;
  isMobile?: boolean;
  isOpen?: boolean;
  toggleDropdown?: (name: string) => void;
  dropdown?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Link: any;
}

const MenuItem = ({
  icon,
  name,
  submenu,
  isMobile,
  isOpen,
  toggleDropdown,
  dropdown,
  Link,
}: MenuItemProps) => {
  const [height, setHeight] = useState<Height | number>(0);

  const handleClick = (name: string) => {
    if (isMobile) {
      setHeight((height) => (height === 0 ? 'auto' : 0));
    }
    toggleDropdown && toggleDropdown(name);
  };

  const SubMenu = () => {
    return (
      <div
        className={classNames('list-style-none bg-white w-100 text-nowrap', {
          'd-flex position-absolute topbar-desktop-submenu px-16 justify-content-between left-0 border-bottom align-items-center':
            !isMobile,
        })}
      >
        <div className={classNames({ 'd-flex': !isMobile })}>
          {submenu &&
            submenu?.leftSubMenus?.map((item) => {
              return (
                <div
                  key={item.name}
                  className={classNames('w-100', {
                    'menu-item-subitems py-6': isMobile && !item.hide,
                    'd-flex align-items-center px-4': !isMobile && !item.hide,
                  })}
                >
                  {!item.hide ? (
                    <Link
                      to={item.url}
                      className={classNames('text-decoration-none', {
                        'd-flex align-items-center': item?.icon,
                      })}
                    >
                      {item.icon ? (
                        <div className="me-4">{item.icon}</div>
                      ) : null}
                      <Text color="title">{item.name}</Text>
                    </Link>
                  ) : null}
                </div>
              );
            })}
        </div>
        <div>
          {submenu &&
            submenu?.rightSubComponents?.map((component, index) => {
              return (
                <div key={index}>
                  {!component.hide ? component.component : null}
                </div>
              );
            })}
        </div>
      </div>
    );
  };

  const MenuLabel = () => {
    return (
      <>
        <div className="d-flex align-items-center gap-6 px-6 py-4">
          {icon && (
            <span className="menu-item-icon d-flex align-items-center justify-content-center">
              {icon}
            </span>
          )}
          <div>
            {showActive() ? (
              <Text color="primary" weight="semibold">
                {name}
              </Text>
            ) : (
              <Text color="title" weight="semibold">
                {name}
              </Text>
            )}
          </div>
        </div>

        {submenu && (
          <div className="d-flex align-items-center">
            {showActive() ? (
              <IconChevronUp size="24" fill="subtitle1" />
            ) : (
              <IconChevronDown size="24" fill="subtitle1" />
            )}
          </div>
        )}
      </>
    );
  };

  const showActive = () => {
    let active = false;
    if (!isMobile) {
      active = isOpen;
    } else {
      active = isOpen && height === 'auto';
    }

    return active;
  };

  return (
    <>
      <div className={classNames({ 'menu-item': isMobile })}>
        <div
          id={name}
          className={classNames('pointer d-flex align-items-center', {
            'justify-content-between': isMobile,
            'bg-primary-lightest rounded-3': showActive(),
          })}
          {...((!dropdown || isMobile) && {
            onClick: () => handleClick(name),
          })}
        >
          {!dropdown || isMobile ? <MenuLabel /> : null}

          {dropdown && !isMobile ? (
            <Dropdown
              buttonType="label"
              buttonLabelName={name}
              listItem={submenu?.leftSubMenus}
              labelIcon={icon}
              Link={Link}
              dropdownPosition="left"
            />
          ) : null}
        </div>
      </div>
      {isMobile ? (
        <AnimateHeight duration={500} height={height}>
          <SubMenu />
        </AnimateHeight>
      ) : (
        isOpen && !dropdown && <SubMenu />
      )}
    </>
  );
};
export default MenuItem;
